export default __webpack_public_path__ + "static/media/Flips-Trilogie-2026_1.450821f5.png";